export const ACTIVITY_TYPES = {
  USER_REGISTERED: 'user_registered',
  PET_REGISTERED: 'pet_registered',
  AI_SCAN: 'ai_scan',
} as const;

export const ACTIVITY_COLORS = {
  [ACTIVITY_TYPES.USER_REGISTERED]: '#1890ff',
  [ACTIVITY_TYPES.PET_REGISTERED]: '#52c41a',
  [ACTIVITY_TYPES.AI_SCAN]: '#722ed1',
} as const;

export const SEVERITY_COLORS = {
  healthy: '#52c41a',
  mild: '#faad14',
  moderate: '#fa8c16',
  severe: '#ff4d4f',
} as const;

export const QUICK_ACTIONS = [
  {
    key: 'add_breed',
    title: 'Add Breed',
    description: 'Create a new breed profile',
    bgColor: 'bg-primary-navy',
  },
  {
    key: 'add_resource',
    title: 'Add Resource',
    description: 'Publish new content',
    bgColor: 'bg-primary-orange',
  },
  {
    key: 'manage_users',
    title: 'Manage Users',
    description: 'View pet owner accounts',
    bgColor: 'bg-health-excellent',
  },
  {
    key: 'view_pets',
    title: 'View Pets',
    description: 'Browse pet profiles',
    bgColor: 'bg-purple-500',
  },
] as const;
